import React from "react";
import {ProfileBadge} from "../../../../../../library/components/profile-badge";

export function PoliciesBadge({status}) {

    return <ProfileBadge onClick={()=>{}} type={status} />
}